import PaginatedList from "#root/components/paginated-list";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { cloudScheduleTaskCollection, getCloudScheduleJobCollectionForTask, } from "#root/schema/platform/cloudschedule";
import PageLayout from "./layout";

export default function TaskListPage({ taskId }): ReactNode {
  const jobCollection = useMemo(() => getCloudScheduleJobCollectionForTask(taskId), [taskId]);

  const [details] = useData(async () => {
    if (taskId) {
      return cloudScheduleTaskCollection.details(taskId);
    }
  }, [taskId]);

  return (
    <PageLayout title={`CloudSchedule - Task ${taskId}`}>
      <PaginatedList title={`${details?.row?.name} - Recent Jobs`} collection={jobCollection} refresh={1000}>
        {({ rows }) => (
          <table className="job-list">
            <thead>
            <tr>
              <th>Job ID</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Status</th>
              <th>Output</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(job => (
              <tr key={job.id} className={job.startTime && !job.endTime ? "highlight" : job.status === "complete" ? "" : "error"}>
                <td>{job.id}</td>
                <td style={{ whiteSpace: "nowrap" }}>{job.startTime ? new Date(job.startTime).toLocaleString() : "Hasn't Run"}</td>
                <td style={{ whiteSpace: "nowrap" }}>{job.endTime ? new Date(job.endTime).toLocaleString() : "Running"}</td>
                <td>{job.status}</td>
                <td>{job.output || "--EMPTY--"}</td>
                <td>
                  <Link to={`/admin/platform/cloudschedule/${taskId}/job/${job.id}`}>View Job Output</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
